import { Filter_State } from './types/filters.type';

export const sortFiltersStateByOrder = (f1: Filter_State, f2: Filter_State): -1 | 0 | 1 => {
    if (f1.configuration.order < f2.configuration.order) {
        return -1;
    }
    if (f1.configuration.order > f2.configuration.order) {
        return 1;
    }
    return 0;
};
